(function () {
  'use strict';

  window.TakeDriveMapInteractionsFactory = function (options) {
    function resetView() {
      var map = options.getMap();
      if (!map) return;
      map.resetTakeDriveWorldView();
    }

    function bindMarker(marker, item) {
      marker.addListener('click', function () {
        window.trackTakeDriveMapEvent('marker_click', options.getMap());
        options.selectStore(item.code, { resultKind: item.resultKind, panTo: false });
        var list = options.root.querySelector('#takeDriveMapResultsList');
        if (!list) return;
        var card = Array.from(list.querySelectorAll('[data-store-code][data-result-kind]')).find(function (element) {
          return element.getAttribute('data-store-code') === String(item.code)
            && element.getAttribute('data-result-kind') === String(item.resultKind || 'dealer');
        });
        if (card) {
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var behavior = reducedMotion ? 'auto' : 'smooth';
          var resultsPanel = options.root.querySelector('#takeDriveDiscoveryActions');
          if (window.matchMedia('(max-width: 734px)').matches && resultsPanel) {
            resultsPanel.scrollTo({
              top: resultsPanel.scrollTop + card.getBoundingClientRect().top - resultsPanel.getBoundingClientRect().top,
              behavior: behavior
            });
          } else {
            card.scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'nearest' });
          }
        }
      });
    }

    function mountControls() {
      var map = options.getMap();
      var controls = document.createElement('div');
      controls.className = 'take-drive-map-controls';
      [
        { event: 'reset', label: options.labels.reset, icon: options.icons.reset, action: resetView },
        { event: 'zoom_in', label: options.labels.zoomIn, icon: options.icons.zoomIn, action: function () { map.setZoom(Math.min(22, (map.getZoom() ?? 4) + 1)); } },
        { event: 'zoom_out', label: options.labels.zoomOut, icon: options.icons.zoomOut, action: function () { map.setZoom(Math.max(map.get('minZoom') || 0, (map.getZoom() ?? 4) - 1)); } }
      ].forEach(function (control) {
        var button = document.createElement('button');
        button.type = 'button';
        var icon = document.createElement('img');
        icon.src = control.icon;
        icon.alt = '';
        icon.width = 24;
        icon.height = 24;
        button.appendChild(icon);
        button.title = control.label;
        button.setAttribute('aria-label', control.label);
        button.addEventListener('click', function () {
          control.action();
          window.trackTakeDriveMapEvent(control.event, map);
        });
        controls.appendChild(button);
      });
      map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controls);
    }

    return { bindMarker: bindMarker, mountControls: mountControls, resetView: resetView };
  };
})();
